import { render } from "./whatsAppLog.vue?vue&type=template&id=1411e54a&scoped=true"
import script from "./whatsAppLog.vue?vue&type=script&lang=js"
export * from "./whatsAppLog.vue?vue&type=script&lang=js"

import "./whatsAppLog.vue?vue&type=style&index=0&id=1411e54a&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1411e54a"]])

export default __exports__